import InteractiveStepperView from './interactive_stepper_view';

const InteractiveStepper = InteractiveStepperView;
export default InteractiveStepper;
